import { useEffect, useState } from 'react'
import { DatePicker } from 'antd'
import moment from 'moment'

const DatePickerNow = ({ ...props }) => {
  const [startTime, setStartTime] = useState<any>(0)

  useEffect(() => {
    setInterval(() => {
      const interval = setInterval(() => {
        setStartTime(moment(new Date()))
      }, 1000)

      return () => {
        clearInterval(interval)
      }
    }, 1000)
  }, [])

  return <DatePicker value={startTime} {...props} />
}

export default DatePickerNow
